
@if (modificationBudgetaire) {
  @if (modificationBudgetaire.fichier) {
    <div class="button-download">
      <mat-icon>download</mat-icon>
      <a (click)="toolService.download(modificationBudgetaire.fichier)" href="javascript:void(0);">
        {{'mesCandidatures.candidature.telechargeDocument' | translate}}
      </a>
    </div>
  }
  @if (modificationBudgetaire.justification.length) {
    <p class="content-justification">
      {{modificationBudgetaire.justification}}
    </p>
  }
  @if (typesFrais) {
    <table class="mb-1">
      <thead>
        <th></th>
        @if (modificationBudgetaire.previousVersion) {
          <th>
            @if (previousVersion?.initiale) {
              {{ 'front.form_modification_budgetaire.versionInitiale' | translate }}
            }
            @if (previousVersion?.initiale === false) {
              {{ 'front.form_modification_budgetaire.versionDu' | translate }}
              {{ previousVersion.dateCreation | date : dateShort}}
            }
          </th>
        }
        <th>
          @if (modificationBudgetaire.initiale) {
            {{ 'front.form_modification_budgetaire.versionInitiale' | translate }}
          }
          @if (!modificationBudgetaire.initiale) {
            {{ 'front.form_modification_budgetaire.revision' | translate }}
          }
        </th>
      </thead>
      <tbody>
        @for (typeFrais of typesFrais; track typeFrais) {
          @if (existsLineForTypeFrais(typeFrais)) {
            <tr>
              <th>{{ translationService.getPropertyTranslationWithFallback(typeFrais, 'label') }}</th>
              @if (modificationBudgetaire.previousVersion) {
                <td>{{ (previousVersionMontants?.get(typeFrais['@id']) ?? 0) | number: '1.0-2' : 'fr' }} €</td>
              }
              <td>{{ montants?.get(typeFrais['@id']) ?? 0  | number: '1.0-2' : 'fr'  }} €</td>
            </tr>
          }
        }
        @if(modificationBudgetaire.montantAdditionnel !== null){
          <tr>
            <th>{{ 'front.suiviProjet.montantAdditionnel' | translate }}</th>
            @if (modificationBudgetaire.previousVersion) {
              <td>{{ (previousVersion.montantAdditionnel ?? 0) | number: '1.0-2' : 'fr' }} €</td>
            }
            <td>{{ (modificationBudgetaire.montantAdditionnel ?? 0)  | number: '1.0-2' : 'fr'  }} €</td>
          </tr>
        }
      </tbody>
      @if (total) {
        <tfoot>
          <tr>
            <th>Total</th>
            @if (modificationBudgetaire.previousVersion) {
              <td>{{ total| number: '1.0-2' : 'fr'  }} €</td>
            }
            <td>{{ total| number: '1.0-2' : 'fr'  }} €</td>
          </tr>
        </tfoot>
      }
    </table>
  }
  @if (modificationBudgetaire.dateStatut && !modificationBudgetaire.initiale) {
    <div>
      {{modificationBudgetaire.dateStatut | date:dateShort}} - {{'front.demandeProlongation.justificationAdmin' | translate }}
      @if (modificationBudgetaire.justificationStatut) {
        <p class="content-justification">
          {{modificationBudgetaire.justificationStatut}}
        </p>
      }
    </div>
  }
}
